<template lang="pug">
  // mock用の仮HTML（CardListをコピペしただけ）
  .table-responsive(data-testid="card-history-list")
    table.table.table-striped.table-bordered.bcard-table
      thead
        tr
          th.bcard-table-td-chk(v-if="checkable")
            label
              input(type="checkbox" @change="$emit('checkAll', list, $event.target.checked)" data-testid="-check-all")
          th.thd-img 名刺画像
          th.thd-name 氏名/会社名
            template(v-if="sort")
              i.fa.bcard-table-sort-header-icon(v-show="sort.sort_item === 'name' || sort.sort_item === 'corporate_name'", :class="'fa-sort-' + sort.direction")
          th.thd-group 部署名/役職
          th.thd-contact 連絡先
          th.thd-address 住所
          th.thd-exchange 名刺交換日/交換者
            template(v-if="sort")
              i.fa.bcard-table-sort-header-icon(v-show="sort.sort_item === 'exchange_date'", :class="'fa-sort-' + sort.direction")
      tbody
        tr(v-for="(item, index) in list", :key="item.id", :class="{selected: $parent.isChecked(item.id)}" :data-testid="item.full_name")
          td.bcard-table-td-chk(v-if="checkable")
            label
              input(type="checkbox", :checked="$parent.isChecked(item.id)", @change="$emit('checkItem', item.id, $event.target.checked)" data-testid="-check")
          td.thd-img
            a(v-if="item.image_url.length !== 0" href="#" @click.prevent="showBcardImageModal(item.id)")
              img(:src="app_imgsrc.now_loading", v-src:thumbnail="item.image_url", :alt="item.full_name", :title="item.full_name")
            img(v-else :src="app_imgsrc.now_loading", v-src:thumbnail="item.image_url")
          td.thd-name
            router-link.text(:to="{name: 'box-history-detail', params: {sidPerson: item.sid_person, sidBcard: item.id}}" data-testid="-link-history-detail")
              i.fa.bcard-fa-person-private(v-if="item.openflag === '0'" title="非公開")
              |
              | {{item.full_name}}
              br
              | {{item.corporate_name}}
            latest-label(:is-latest="item.is_latest")
          td {{item.dept}}
            br
            | {{item.post}}
          td
            .media(v-if="item.o1_tel1 || item.o1_mobile")
              .media-left
                i.fa.fa-fw.fa-phone
              .media-body
                div(v-if="item.o1_tel1") {{item.o1_tel1}}
                div(v-if="item.o1_mobile") {{item.o1_mobile}}
            .media(v-if="item.o1_mail")
              .media-left
                i.fa.fa-fw.fa-envelope-o
              .media-body
                a(:href="'mailto:' + item.o1_mail") {{item.o1_mail}}
          td
            .media(v-if="item.o1_zipcode || item.o1_address1 || item.o1_address2")
              .media-left
                i.fa.fa-fw.fa-map-marker
              .media-body
                div(v-if="item.o1_zipcode") 〒{{item.o1_zipcode}}
                div(v-if="item.o1_address1 || item.o1_address2")
                  address-link(:addresses="[item.o1_address1, item.o1_address2]")
          td {{item.formatted_exdate}}
            br
            exchanger-names(:exchanges="item.exchanges")

    //- 名刺画像ダイアログ
    modal-images(v-model="modalImages")
</template>

<script>
import LatestLabel from '@/components/molecules/LatestLabel'
import AddressLink from '@/components/molecules/AddressLink'
import ExchangerNames from '@/components/molecules/ExchangerNames'
import ModalImages from '@/components/organisms/ModalImages'

export default {
  name: 'CardHistoryList',
  components: { LatestLabel, AddressLink, ExchangerNames, ModalImages },
  props: {
    value: { type: Array, required: true },
    checkable: { type: Boolean, required: false, default: false },
    pCheckedIds: { type: Array, required: true },
    sort: {
      type: Object,
      required: false,
      default () {
        return {
          // ページ条件
          page: { page: 1 },
          // ソート条件
          sort: { sort_item: 'name', direction: 'asc' },
          // 検索条件
          conds: {}
        }
      }
    }
  },
  data () {
    return {
      list: [],
      checkedIds: [],
      // 名刺画像ダイアログ
      modalImages: {
        isOpen: false,
        sid_bcard: null
      }
    }
  },
  watch: {
    pCheckedIds (pCheckedIds) {
      this.syncCheckedIds(pCheckedIds)
    },
    value (value) {
      this.syncList(value)
    }
  },
  created () {
    this.syncCheckedIds(this.pCheckedIds)
    this.syncList(this.value)
    // this.setMockData()
  },
  methods: {
    syncCheckedIds (checkedIds) {
      this.checkedIds = checkedIds
    },
    syncList (list) {
      this.list = list
    },
    // 名刺画像ダイアログ表示
    showBcardImageModal: function (sid_bcard) {
      this.modalImages.isOpen = true
      this.modalImages.sid_bcard = sid_bcard
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~bootstrap-sass/assets/stylesheets/bootstrap/variables';

  /**
   * チェックボックスの反応範囲を広げる
   */
  .bcard-table-td-chk {
    position: relative;
    min-height: 38px;

    label {
      margin: 0;
      padding: 0;
      cursor: pointer;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;

      /* radioを上下中央に配置する */
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        background-color: #f4f4f5;
      }
    }
  }

  .mode-card {
    .bcard-table {
      thead {
        th {
          display: none;
        }

        th.bcard-table-td-chk {
          display: block;
          text-align: left;
          width: 100%;

          label {
            display: block; // flex取り消し
            padding: 8px 15px;
            line-height: 19px;

            &:after {
              content: 'すべて選択';
              margin-left: 1.2em;
            }
          }
        }
      }

      tbody {
        display: flex;
        flex-wrap: wrap;
        align-items: stretch;
        padding: 10px;

        tr {
          margin: 5px;
          width: calc(100% - 10px);
          display: block;
          border: 1px solid #ddd;
          border-radius: 10px;
          background-color: inherit;
        }

        @media (min-width: $screen-sm-min) {
          tr {
            width: calc(50% - 10px);
          }
        }

        @media (min-width: $screen-lg-min) {
          tr {
            width: calc(33.333% - 10px);
          }
        }

        td {
          display: block;
          border: 0;
          width: 100%;

          &.thd-img {
            text-align: center;
          }
        }

        .bcard-table-td-chk label {
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
        }
      }
    }
  }

  // 電話番号
  td .media {
    margin-top: 0;
    .media-left {
      padding-right: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/organisms/lists/CardHistoryList.vue